import React from 'react'

const CategoryViewResult = ({result}) => {
  const discoveredClassificationValue = result?.discovered_classification?.category?.primary?.value
  const discoveredClassificationConfidence = result?.discovered_classification?.category?.primary?.confidence
  const discoveredClassificationEvidence = result?.discovered_classification?.category?.primary?.evidence

  const discoveredClassificationIndustryValue = result?.discovered_classification?.industry?.primary?.value
  const discoveredClassificationIndustryConfidence = result?.discovered_classification?.industry?.primary?.confidence
  const discoveredClassificationIndustryEvidence = result?.discovered_classification?.industry?.primary?.evidence

  const discoveredClassificationDocumentTypeValue = result?.discovered_classification?.document_type?.primary?.value
  const discoveredClassificationDocumentTypeConfidence = result?.discovered_classification?.document_type?.primary?.confidence
  const discoveredClassificationDocumentTypeEvidence = result?.discovered_classification?.document_type?.primary?.evidence

  const formatEvidence = (evidence) => {
    if (Array.isArray(evidence)) {
      return evidence.join('; ')
    }
    return evidence || '-'
  }

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr className="bg-base-200">
            <th className="font-bold">Type</th>
            <th className="font-bold">Value</th>
            <th className="font-bold">Evidence</th>
            <th className="font-bold">Confidence</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Category</td>
            <td>{discoveredClassificationValue || '-'}</td>
            <td>{formatEvidence(discoveredClassificationEvidence)}</td>
            <td>{discoveredClassificationConfidence ? `${(discoveredClassificationConfidence)}%` : '-'}</td>
          </tr>
          <tr>
            <td>Industry</td>
            <td>{discoveredClassificationIndustryValue || '-'}</td>
            <td>{formatEvidence(discoveredClassificationIndustryEvidence)}</td>
            <td>{discoveredClassificationIndustryConfidence ? `${(discoveredClassificationIndustryConfidence)}%` : '-'}</td>
          </tr>
          <tr>
            <td>Document Type</td>
            <td>{discoveredClassificationDocumentTypeValue || '-'}</td>
            <td>{formatEvidence(discoveredClassificationDocumentTypeEvidence)}</td>
            <td>{discoveredClassificationDocumentTypeConfidence ? `${(discoveredClassificationDocumentTypeConfidence)}%` : '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default CategoryViewResult;